import { FC } from "react";
import { EvolutionTabNavigation } from "@/components/EvolutionTabNavigation";
import { isEditing } from "@builder.io/sdk-react";

export const EvolutionTabNavigationBlock: FC = () => (
  <EvolutionTabNavigation tabClickOverride={isEditing()} />
);
